import Column from '@components/Column';
import Row from '@components/Row';
import styled from '@emotion/styled';
import useItemCategories from '@hooks/category/useItemCategories';
import { useContext } from 'react';

import ItemCategory from './ItemCategory';
import ItemCategorySkeletons from './ItemCategorySkeletons';
import ItemFilters from './ItemFilters';
import ShopItemContext from '../../context/ShopItemContext';

function ItemCategories() {
    const { shopId } = useContext(ShopItemContext);
    const { categories, isLoading } = useItemCategories(shopId);
    return (
        <Column fullWidth>
            <Container spacing={2} fullWidth>
                <ItemFilters/>
                <ContentsRow spacing={2} >
                    {isLoading && (<ItemCategorySkeletons/>)}
                    {categories?.map((category) => (
                        <ItemCategory key={category.id}
                            categories={categories}
                            itemCategory={category}/>
                    ))}
                </ContentsRow>
            </Container>
        </Column>
    );
}

const Container = styled(Row)`
    max-width: 100%;
    padding: var(--spacing-4) 0 var(--spacing-4) var(--spacing-5);
    border-bottom: 1px solid var(--color-border-default);
`;

const ContentsRow = styled(Row)`
    flex: 1;
    overflow-x: auto;
    padding-right: 20px;
    &::-webkit-scrollbar {
        display: none;
    }
`;

export default ItemCategories;
